import { darkBlue, energyRed, landGreen } from '../theme/foundations/colors'

const baseStyle = {
  color: 'darkBlue.main',
}

const defaultProps = {
  size: 'md',
  variant: 'primary',
}

const sizes = {
  sm: {
    strokeWidth: 4,
    width: 46,
    top: 15,
    fontSize: 12,
  },
  md: { strokeWidth: 5, width: 80, top: 30, fontSize: 16 },
  lg: { strokeWidth: 6, width: 120, top: 48, fontSize: 18 },
  xl: { strokeWidth: 7, width: 160, top: 64, fontSize: 22 },
}

const variants = {
  primary: {
    stroke: {
      main: darkBlue[95],
      progress: darkBlue.main,
    },
  },
  green: {
    stroke: {
      main: landGreen[95],
      progress: landGreen.main,
    },
  },
  red: {
    stroke: {
      main: energyRed[95],
      progress: energyRed.main,
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
